import React from "react";
import { Link } from "react-router-dom";
import AOSInitializer from "../../AOSInitializer";

export const BusinessWritingCards = () => {
  return (
    <>
      <AOSInitializer />
      <div className="row">
        {/* card 01 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/business1.jpg"
                  alt="Service Frequency Calculator"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <Link className="" to="/Business_Services">
                    Business Plans
                  </Link>
                </h3>
                <p>
                  Crafting comprehensive plans that outline the business’s
                  strategy, financial forecasts, and market analysis.
                </p>
                <Link to="/Business_Services">Check Now</Link>
              </div>
            </div>
          </div>
        </div>
        {/* card 02 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/business2.jpg"
                  alt="Service Frequency Calculator"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <Link className="" to="/Business_sub_Services">
                    Grant Proposals
                  </Link>
                </h3>
                <p>
                  Writing proposals to secure funding from government entities,
                  foundations, and other organizations.
                </p>
                <Link to="/Business_Services">Check Now</Link>
              </div>
            </div>
          </div>
        </div>
        {/* card 03 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/business3 (2).jpg"
                  alt="Service Frequency Calculator"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <Link className="" to="/Business_Services">
                    Annual Reports
                  </Link>
                </h3>
                <p>
                  Developing detailed annual reports that communicate business
                  achievements and financial status to stakeholders.
                </p>
                <Link to="/Business_Services">Check Now</Link>
              </div>
            </div>
          </div>
        </div>
        {/* card 04 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/business4.jpg"
                  alt="Service Frequency Calculator"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <Link className="" to="/Business_sub_Services">
                    Press Releases
                  </Link>
                </h3>
                <p>
                  Creating press releases to announce company news, product
                  launches, or changes in leadership, aimed at media outlets.
                </p>
                <Link to="/Business_sub_Services">Check Now</Link>
              </div>
            </div>
          </div>
        </div>
        {/* card 05 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/business5.jpg"
                  alt="Service Frequency Calculator"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <Link className="" to="/Business_sub_Services">
                    Newsletters
                  </Link>
                </h3>
                <p>
                  Producing engaging newsletters for internal staff updates or
                  external customer engagement.
                </p>
                <Link to="/Business_sub_Services">Check Now</Link>
              </div>
            </div>
          </div>
        </div>
        {/* card 06 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/business6.jpg"
                  alt="Service Frequency Calculator"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <Link className="" to="/Business_sub_Services">
                    Website Content
                  </Link>
                </h3>
                <p>
                  Writing or revamping content for websites, including landing
                  pages, about us sections, and product descriptions.
                </p>
                <Link to="/Business_sub_Services">Check Now</Link>
              </div>
            </div>
          </div>
        </div>
        {/* card 07 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/business7.jpg"
                  alt="Service Frequency Calculator"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <Link className="" to="/Business_sub_Services">
                    Case Studies
                  </Link>
                </h3>
                <p>
                  Documenting customer success stories or product applications
                  to demonstrate the value and impact of a company’s offerings.
                </p>
                <Link to="/Business_sub_Services">Check Now</Link>
              </div>
            </div>
          </div>
        </div>
        {/* card 08 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/business8.jpg"
                  alt="Service Frequency Calculator"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <Link className="" to="/Business_sub_Services">
                    Social Media Content
                  </Link>
                </h3>
                <p>
                  Generating content for platforms like LinkedIn, Twitter, and
                  Facebook to enhance online presence and engage with the
                  audience.
                </p>
                <Link to="/Business_sub_Services">Check Now</Link>
              </div>
            </div>
          </div>
        </div>
        {/* card 09 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/business9.jpg"
                  alt="Service Frequency Calculator"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <Link className="" to="/Business_sub_Services">
                    Training Manuals
                  </Link>
                </h3>
                <p>
                  Developing comprehensive guides and manuals for new employees
                  or for training purposes on various processes.
                </p>
                <Link to="/Business_sub_Services">Check Now</Link>
              </div>
            </div>
          </div>
        </div>
        {/* card 10 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="fade-up">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/business10.jpeg"
                  alt="Service Frequency Calculator"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <Link className="" to="/Business_sub_Services">
                    Executive Speeches
                  </Link>
                </h3>
                <p>
                  Crafting speeches for company executives for events,
                  conferences, or internal meetings, tailored to convey key
                  messages clearly and effectively.
                </p>
                <Link to="/Business_sub_Services">Check Now</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessWritingCards;
